import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {crudifyMutations, byId, hydrateEdit, resetResults, savePayload} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import {maybeAppendInactive} from '@/utilities/utils'

const state = {
  edit: {
    id: null,
    name: null,
    active: true
  },
  results: [],
  autocompleteResults: []
}

const getters = make.getters(state)
getters.byId = byId
getters.savePayload = savePayload

const mutations = make.mutations(state)

mutations.reset = (state) => {
  mutations.resetResults(state)
  mutations.resetAutocompleteResults(state)
  mutations.resetEdit(state)
}

mutations.resetResults = resetResults
mutations.hydrateEdit = hydrateEdit
mutations.resetAutocompleteResults = (state) => {
  state.autocompleteResults = []
}
crudifyMutations(mutations)

mutations.resetEdit = (state) => {
  state.edit = {
    id: null,
    name: null,
    active: true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByName({commit}, payload) {
      commit('resetResults')
      const response = await ptracGetEntities(`legal-subdivisions/search/findByNameStartsWithIgnoreCaseAndActiveOrderByNameAsc?name=${payload.query}&active=${payload.active}`)
      if (OK === response.status) {
        commit('results', response.data)
      }
      return response
    },
    async fetchByNameStartsWith({commit}, text) {
      commit('resetAutocompleteResults')
      const response = await ptracGetEntities(`legal-subdivisions/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=${text}`)
      if (OK === response.status) {
        commit('autocompleteResults', maybeAppendInactive(response.data))
      }
      return response
    }
  }
}
